import { DesktopNavigationMenuProps, GlobalNavigationBar, MobileNavigationMenuProps, SystemIcons } from '@laerdal/life-react-components';
import { useTranslation } from 'react-i18next';
import { Brasil, USA } from './Flags';
import { useEffect, useState } from 'react';
import { selectLocale, selectMarket } from '../store/slices/globalConfigSlice';
import { useSelector } from 'react-redux';
import { selectGigyaAccount, selectIsAuthenticated, selectUserProfile } from '../store/slices/userSlice';
import { ProfileComponent } from "@laerdal/navigation"

const Header = () => {
    const { t, i18n } = useTranslation('translation');
    const [desktopMenu, setDesktopMenu] = useState<DesktopNavigationMenuProps>();
    const [mobileMenu, setMobileMenu] = useState<MobileNavigationMenuProps>();
    const currentLocale = useSelector(selectLocale);
    const isAuthenticated =useSelector(selectIsAuthenticated);
    const account = useSelector(selectGigyaAccount);
    const user = useSelector(selectUserProfile);
    const currentMartket = useSelector(selectMarket);
    
    
    useEffect(() => {
      var signedInConfig = {
        items: [
          {
            label: t('Home'),
            to: '/',
            exact: true
          }   
        ],
        buttons:[
          {
            type: 'profile'
          },
          {
            type: 'switcher',
            action: () => { window.globalNav?.show(); }
          },
        ],      
        action: {
          label: t('Dashboard'),
          action: () => { window.location.href = process.env.REACT_APP_CONNECT_LINK ?? ''}
        },
      } as DesktopNavigationMenuProps;
            
      var unauthorizedConfig = {
        items: [
          {
            label: t('Home'),
            to: '/',
            exact: true
          }   
        ],
        action:{
          action: ()=>{
            // @ts-ignore
            window.gigya.sso.login({
              authFlow: 'redirect',
              redirectURL: window.location.href,
              useChildContext: true,
              context: {
                application: 'Support',
                lng: i18n.language
              }
            });
          },
          label: t('Login'),
        }
      } as DesktopNavigationMenuProps;
      

      setDesktopMenu( !!user ? signedInConfig : unauthorizedConfig);
      
      setMobileMenu({
        items: [
          {
            label: t('Home'),
            to: '/',
            exact: true
          }
        ],
        
      });
    }, [i18n.language, currentLocale, isAuthenticated, account, user]);
    
    return (
        <GlobalNavigationBar
            isAuthenticated={true}
            name={t('Support')}
            logo={{
              to: '/'
            }}
            useMaxWidth={true}
            desktop={desktopMenu}
            mobile={mobileMenu}

            profileComponent= { !!user ?
              <ProfileComponent
                organizationName={user.currentOrganization?.name}
                customContent={{
                  title: t('Support'),
                  items: []
                }}
                user={  {
                  firstName: user.firstName,
                  lastName: user.lastName,
                  email: user.email,
                  market: currentMartket
                }}
                //@ts-ignore
                env={ process.env.REACT_APP_SWITCHER_ENV}
                locale={ i18n.language }
                onSignOut={() => {               
                  // @ts-ignore
                  window.gigya.accounts.logout(); 
                }}
                hideLaguage={true}
              /> : undefined
            }
        />
    );
}

export default Header;